import { useState } from 'react'
import { useAuthStore } from '@carouselgg/auth/store'
import { NotificationProvider } from '../context/NotificationContext'
import { AppLayout } from './AppLayout'
import { PublicLayout } from './PublicLayout'
import { chooseShell, readShell } from './shell'

/**
 * Layout for the discovery pages reachable from BOTH nav systems —
 * `/compete`, `/leagues`, `/orgs`, `/universities`, `/news`, `/how-it-works`,
 * `/privacy`, `/terms`.
 *
 * They keep whichever shell the visitor was already browsing in; see shell.ts
 * for the rule. `/` is deliberately NOT here — it is the marketing page and
 * gets marketing chrome for everyone.
 */
export function DiscoveryLayout() {
  const isLoading = useAuthStore((s) => s.isLoading)
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const sessionId = useAuthStore((s) => s.sessionId)
  // Read once per mount. Moving between two discovery pages keeps this layout
  // mounted (they share it), so the shell holds. Arriving from the dashboard or
  // from `/` mounts it fresh, by which point that shell has recorded itself.
  const [lastShell] = useState(readShell)

  const shell = chooseShell({
    isLoading,
    isAuthenticated,
    hasSession: Boolean(sessionId),
    lastShell,
  })

  if (shell === 'app') {
    return (
      <NotificationProvider>
        <AppLayout />
      </NotificationProvider>
    )
  }

  return <PublicLayout />
}
